<template>
  <div class="animated fadeIn form-abm">
    <b-row>
      <b-col xl="12">
        <b-form>
          <b-card header= "Datos de la Participación">
            <b-form-group
              label="Código"
              label-for="codigoPromocion"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="codigoPromocion"
                :value="codigoPromocion" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <!-- <b-form-group
              label="Nro.Documento"
              label-for="documentoNumero"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="documentoNumero"
                :value="documentoNumero" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group> -->

            <b-form-group
              label="CUIT"
              label-for="cuit"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="cuit"
                :value="cuit" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>
          </b-card>

          <b-card header= "Datos del Negocio">
            <!-- <b-form-group
              label="Nombre Comercial"
              label-for="nombreComercial"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="nombreComercial"
                :value="nombreComercial" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group> -->

            <b-form-group
              label="Razón Social"
              label-for="razonSocial"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="razonSocial"
                :value="razonSocial" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Provincia"
              label-for="provincia"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="provincia"
                :value="negocioProvincia" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Localidad"
              label-for="localidad"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="localidad"
                :value="negocioLocalidad" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Barrio"
              label-for="barrio"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="barrio"
                :value="negocioBarrio" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Dirección"
              label-for="direccion"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="direccion"
                :value="negocioDireccion" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>

            <b-form-group
              label="Cod.Postal"
              label-for="codigoPostal"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="codigoPostal"
                :value="negocioCodigoPostal" 
                type="text"
                readonly>
              </b-form-input>
            </b-form-group>
          </b-card>
        </b-form>
      </b-col>
    </b-row>

    <app-a-b-m-button
      @save="save"
      @cancel="goList">
    </app-a-b-m-button>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      :modalVariant="modalVariant"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import ABMButtons from '../shared/abmButtons.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'participanteReinscripcion/getField',
  mutationType: 'participanteReinscripcion/updateField',
});

export default {
  name: 'ParticipanteReinscripcionConfirmacion',
  components: {
    appABMButton: ABMButtons,
    appMensaje: Mensaje
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      labelCols: 2,
    }
  },
  computed: {
    ...mapFields([
      'eventoId',
      'codigoPromocion',
      /* Datos del negocio */
      'razonSocial',
      'cuit',
      'negocioProvincia',
      'negocioLocalidad',
      'negocioBarrio',
      'negocioDireccion',
      'negocioCodigoPostal',
    ]),
  },  
  created() {
    if (this.eventoId == 0) {
      this.showModalMsj('Se produjo un error al recuperar los datos del participante', this.goList, this.goList, 'danger');
    }
  },  
  methods: {
    save () {
      this.showSpinner();
      this.$store.dispatch('participanteReinscripcion/save')
        .then(()  => this.showModalMsj('La reinscripción se registró con éxito.', this.goList, this.goList, 'light'))
        .catch(error => this.showErrorMsj(error))
        .finally(() => this.hideSpinner())
    },
    goList() {
      this.$router.push({ name: 'Participantes', 
                          params: { eventoId: this.eventoId }});
    },
  },
  watch: {
  },
}
</script>

<style>
</style>
